import { SupplierRegionCreatableInterface } from '../interfaces/supplier-region-creatable.interface';
import { SupplierRegionDto } from './supplier-region.dto';
import { PickType } from '@nestjs/swagger';

export class SupplierRegionCreateDto
  extends PickType(SupplierRegionDto, ['supplierId', 'regionId'])
  implements SupplierRegionCreatableInterface {}
